import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCustomerServiceToolPanel extends Layout {
    buttonDispatch: Button;
    buttonHold: Button;
    buttonOrderHistory: Button;
    buttonRateOrders: Button;
    buttonReleaseToBilling: Button;
    buttonUpdateField: Button;
    panelButtons: Panel;
    panelLeft: Panel;
    panelRight: Panel;
}
